import { render, staticRenderFns } from "./channel_details.vue?vue&type=template&id=3441fa1a&scoped=true"
import script from "./channel_details.vue?vue&type=script&lang=js"
export * from "./channel_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3441fa1a",
  null
  
)

export default component.exports